import { WAIT_RENDER_SERVER, RENDER_SERVER } from './types'

function waitRenderServer() {
  return {
    type: WAIT_RENDER_SERVER,
    payload: {
      wait: true,
    },
  }
}

function renderServer() {
  return {
    type: RENDER_SERVER,
    payload: {
      render: true,
    },
  }
}

export { waitRenderServer, renderServer }
